export const BillboardAd = ({ brand, copy, variant = "gold", tagged = true, compact = false }) => (
    <div className={`ad-creative ad-${variant} ${compact ? "ad-compact" : ""}`} data-testid="mock-ad-creative">
        <div className="ad-brand">{brand}</div>
        <div className="ad-copy">{copy}</div>
        {tagged && <span className="ad-sample-tag">SAMPLE</span>}
    </div>
);
